import { usePageMeta } from "@/hooks/usePageMeta";
import { SITE } from "@/lib/constants";

function LegalPage({ title, intro, sections }) {
  return (
    <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
      <h1 className="font-heading text-3xl font-bold text-ink sm:text-4xl">{title}</h1>
      <p className="mt-2 text-sm text-ink-muted">Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long" })}</p>
      <p className="mt-6 leading-relaxed text-ink-soft">{intro}</p>
      <div className="mt-8 space-y-8">
        {sections.map((s) => (
          <section key={s.h}>
            <h2 className="font-heading text-xl text-ink">{s.h}</h2>
            <p className="mt-2 leading-relaxed text-ink-soft">{s.p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}

export function Privacy() {
  usePageMeta("Privacy Policy", "How Nicee collects and protects your information.");
  return (
    <LegalPage
      title="Privacy Policy"
      intro={`At ${SITE.name}, we respect your privacy. This policy explains what information we collect when you use our store and how we use it.`}
      sections={[
        { h: "Information we collect", p: "We collect your full name, mobile number and delivery address when you register and place orders. This information is used solely to process and deliver your orders." },
        { h: "How we use your data", p: "Your details are used to confirm orders, arrange delivery, and contact you about your order status. We do not sell or share your personal information with third parties for marketing." },
        { h: "Order communication", p: "When you place an order, order details may be shared via WhatsApp with our team purely to fulfil your delivery." },
        { h: "Data security", p: "Passwords are securely hashed and never stored in plain text. We use industry-standard measures to protect your data." },
        { h: "Contact", p: `For any privacy questions, email us at ${SITE.email}.` },
      ]}
    />
  );
}

export function Terms() {
  usePageMeta("Terms & Conditions", "Terms of service for using the Nicee store.");
  return (
    <LegalPage
      title="Terms & Conditions"
      intro={`By using ${SITE.name}, you agree to the following terms.`}
      sections={[
        { h: "Ordering", p: "Products are available to order only when listed in our store. Prices, discounts and availability may change without prior notice." },
        { h: "Payment", p: "We currently accept Cash on Delivery (COD) only. Payment is collected at the time of delivery." },
        { h: "Delivery", p: "Delivery charges depend on your area and are shown at checkout. We aim to deliver promptly but times may vary based on demand and location." },
        { h: "Cancellations", p: "Orders may be cancelled before dispatch. Please contact us on WhatsApp as soon as possible for any changes." },
        { h: "Product quality", p: "We take great care to deliver fresh products. If you receive damaged goods, contact us within 24 hours and we will make it right." },
        { h: "Contact", p: `Questions about these terms? Email ${SITE.email}.` },
      ]}
    />
  );
}
